import commonStyles from "../Registration/registration.module.scss";

const Spinner = () => (
	<svg className={commonStyles.spinner} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
		<circle fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
	</svg>
);

export default Spinner;